import React from 'react';
import styled from 'styled-components';
import { Level, Title } from 'rbx';
import { first } from 'lodash';
import { Input, Radio, Select } from '../../../components/elements';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const TitleWrapper = styled.nav`
  padding-right: 1rem;
`;

const discount_types = [
  { value: '', label: 'All' },
  { value: 'listing_only', label: 'Listing Only' },
  { value: 'flat_amount_discount', label: 'Flat Amount Discount' },
  { value: 'percentage_discount', label: 'Percentage Discount' },
  { value: 'delivery_fee_discount', label: 'Delivery Fee Discount' },
  { value: 'buy_one_get_one_promo', label: 'Buy One Get One Promo' },
  { value: 'specific_item_discount', label: 'Specific Item Discount' },
];

const Search = ({
  userName,
  setUserName,
  status,
  setStatus,
  voucherNameSearch,
  handleVoucherNameSearch,
  setDiscountType,
  discountType,
  dealStatus,
  defaultPlace,
  setDealStatus,
}) => {
  const discountTypeValue = discount_types.filter(
    item => item.value === discountType,
  );

  return (
    <Wrapper>
      <Level>
        <Level.Item align="left">
          <Level.Item>
            <TitleWrapper>
              <Title className="label">Status</Title>
            </TitleWrapper>
          </Level.Item>
          <Level.Item>
            <Radio
              label="ACTIVE"
              value={dealStatus === 'ACTIVE'}
              onChange={() => {
                setDealStatus('ACTIVE');
              }}
            />
          </Level.Item>
          <Level.Item>
            <Radio
              label="INACTIVE"
              value={dealStatus === 'INACTIVE'}
              onChange={() => {
                setDealStatus('INACTIVE');
              }}
            />
          </Level.Item>
        </Level.Item>

        <Level.Item align="right">
          <Level.Item>
            <TitleWrapper>
              <Title className="label">User Deal Status</Title>
            </TitleWrapper>
          </Level.Item>
          <Level.Item>
            <Radio
              label="Current"
              value={status === 'CURRENT'}
              onChange={() => {
                setStatus('CURRENT');
              }}
            />
          </Level.Item>
          <Level.Item>
            <Radio
              label="Past"
              value={status === 'PAST'}
              onChange={() => {
                setStatus('PAST');
              }}
            />
          </Level.Item>
          <Level.Item>
            <Radio
              label="Future"
              value={status === 'FUTURE'}
              onChange={() => {
                setStatus('FUTURE');
              }}
            />
          </Level.Item>
        </Level.Item>
      </Level>
      <BoxWrapper className="box">
        <div className="columns">
          <div className="column is-3">
            <Input
              label="User Name"
              type="text"
              value={userName}
              onChange={event => setUserName(event.target.value)}
              placeholder="Start entering user name..."
              key={defaultPlace}
            />
          </div>

          <div className="column is-3">
            <Input
              label="Deal Name"
              type="text"
              value={voucherNameSearch}
              onChange={event => handleVoucherNameSearch(event.target.value)}
              placeholder="Start entering voucher name..."
            />
          </div>
          <div className="column is-3">
            <Select
              label="Discount Type"
              options={discount_types}
              value={discountTypeValue.length !== 0 && first(discountTypeValue)}
              onChange={({ value }) => setDiscountType(value)}
            />
          </div>
        </div>
      </BoxWrapper>
    </Wrapper>
  );
};

export default Search;
